import { useState, useEffect } from 'react'
import { FaFax, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import web2 from '../assets/web2.jpg';
import AOS from "aos";
import "aos/dist/aos.css";
import warehouse from '../assets/0.jpeg';
import { useTranslation } from 'react-i18next';
import { BASE_API } from '../Config/Config';

function Contact() {
    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        msg: ""
    })

    const location = useLocation();
    const { t } = useTranslation();

    const handleContact = async (e) => {
        e.preventDefault();

        if (contactForm?.name && contactForm?.email && contactForm?.msg) {
            const formData = new FormData();
            formData.append("name", contactForm.name);
            formData.append("email", contactForm.email);
            formData.append("query", contactForm.msg);

            try {
                const response = await fetch(`${BASE_API}/apis/contact.php`, {
                    method: "POST",

                    body: formData
                });

                const data = await response.json();
                console.log(data);

            } catch (error) {
                console.error("Error:", error);
            }

        } else {
            alert(t('allFieldsMandatory'));
        }
    }

    useEffect(() => {
        getcontact();
    }, [])

    const getcontact = async () => {
        try {
            const response = await fetch(`${BASE_API}/apis/contact_show.php`, {
                method: "POST",
                body: new FormData(),
            });

            const result = await response.json();

            if (result.status === "success") {
                setData(result.data || []);
                setError("");
            } else {
                setData([]);
                setError(result.message || "No data found");
            }

        } catch (err) {
            console.error("Fetch Error:", err);
            setError("Failed to fetch warehouse data");
        }
    };

    const maskPhone = (phone = "") => {
        if (!phone) return "";

        const value = String(phone);

        if (value.length <= 2) {
            return "*".repeat(value.length);
        }

        return `${value[0]}${"*".repeat(value.length - 2)}${value[value.length - 1]}`;
    };

    const maskEmail = (email = "") => {
        if (!email || !email.includes("@")) return "";

        const [username, domain] = email.split("@");

        if (username.length <= 2) {
            return `${username[0] || ""}${"*".repeat(Math.max(username.length - 1, 0))}@${domain}`;
        }

        return `${username.slice(0, 2)}${"*".repeat(username.length - 2)}@${domain}`;
    };

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);


    return (
        <div >

            <div className="position-relative "
                style={location.pathname === "/" ? { marginTop: "370px" } : { marginTop: "0px" }}>

                {location.pathname === "/" &&
                    <div
                        className="position-relative w-100 overflow-hidden"
                        style={{ height: "320px" }}
                        data-aos="fade-up"
                    >
                        <svg
                            viewBox="0 0 1440 320"
                            preserveAspectRatio="none"
                            className="position-absolute bottom-0 start-0 w-100 h-100"
                        >
                            <path
                                d="
                             M0,160
                             Q720,-120 1440,160
                             L1440,320
                             L0,320
                             Z"
                                className=""
                                style={{ fill: "rgba(9, 26, 58, 1)" }}
                            />
                        </svg>
                    </div>
                }

                {location.pathname !== "/about/warehouse-offices" &&
                    <section className="contact-section1d py-5 position-relative "
                        style={{
                            ...(location.pathname !== "/contact-us" ? { marginTop: "-650px" } : { marginTop: "0px" }),
                            zIndex: 10,           // above curve
                        }}
                    >
                        <div className="container">

                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-9">

                                    {/* Heading */}
                                    <div className="text-center mb-5" data-aos="fade-up">
                                        <h2 className="fw-bold">{t('contactTitle')}</h2>
                                        <p className="text-muted">
                                            {t('contactDesc')}
                                        </p>
                                    </div>

                                    <div className="row align-items-stretch">
                                        {/* Contact Info */}
                                        <div
                                            className="col-md-5 mb-4 mb-md-0"
                                            data-aos="fade-right"
                                        >
                                            <div className="contact-info1 h-100">
                                                <h4 className="mb-4">{t('contactReachUs')}</h4>

                                                {/* Address */}
                                                <div className="info-item">
                                                    <FaMapMarkerAlt />
                                                    <p>{t('contactAddress')}</p>
                                                </div>

                                                {/* Phone */}
                                                <div className="info-item">
                                                    <FaPhoneAlt />

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            window.location.href = `tel:${t("contactPhoneog1")}`
                                                        }
                                                        className="info-item border-0 bg-transparent p-0"
                                                        style={{
                                                            color: "inherit",
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <p>{t("contactPhone1")}</p>
                                                    </button>

                                                    <span>,</span>

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            window.location.href = `tel:${t("contactPhoneog2")}`
                                                        }
                                                        className="info-item border-0 bg-transparent p-0"
                                                        style={{
                                                            color: "inherit",
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <p>{t("contactPhone2")}</p>
                                                    </button>
                                                </div>

                                                {/* Fax */}
                                                <div className="info-item">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            window.location.href = `tel:${t('faxog')}`
                                                        }
                                                        className="info-item border-0 bg-transparent p-0"
                                                        style={{
                                                            color: "inherit",
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <FaFax />
                                                        <p>{t('fax')}</p>
                                                    </button>
                                                </div>

                                                {/* Email */}
                                                <div className="info-item">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            window.location.href = `mailto:${t('contactEmailog')}`
                                                        }
                                                        className="info-item border-0 bg-transparent p-0"
                                                        style={{
                                                            color: "inherit",
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <FaEnvelope />
                                                        <p>{t('contactEmail')}</p>
                                                    </button>
                                                </div>

                                                {/* WhatsApp */}
                                                <div className="info-item">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            window.open(
                                                                `https://wa.me/${t('whatsappog').replace(/\D/g, '')}`,
                                                                "_blank",
                                                                "noopener,noreferrer"
                                                            )
                                                        }
                                                        className="info-item border-0 bg-transparent p-0"
                                                        style={{
                                                            color: "inherit",
                                                            textDecoration: "none",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <FaWhatsapp />
                                                        <p>{t('whatsapp')}</p>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>


                                        {/* Contact Form */}
                                        <div
                                            className="col-md-7"
                                            data-aos="fade-left"
                                        >
                                            <div className="contact-form">
                                                <form onSubmit={handleContact} noValidate>

                                                    {/* Name */}
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="text"
                                                            id="name"
                                                            name="name"
                                                            className="form-control"
                                                            placeholder={t('contactName')}
                                                            value={contactForm?.name || ""}
                                                            maxLength={100}
                                                            required
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Only English letters and spaces
                                                                if (/^[A-Za-z ]*$/.test(value)) {
                                                                    setContactForm((pv) => ({
                                                                        ...pv,
                                                                        name: value
                                                                    }));
                                                                }
                                                            }}
                                                        />

                                                        <label htmlFor="name">
                                                            {t('contactName')}
                                                        </label>
                                                    </div>


                                                    {/* Email */}
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            className="form-control"
                                                            placeholder={t('contactEmailLabel')}
                                                            value={contactForm?.email || ""}
                                                            maxLength={254}
                                                            required
                                                            onChange={(e) =>
                                                                setContactForm((pv) => ({
                                                                    ...pv,
                                                                    email: e.target.value
                                                                }))
                                                            }
                                                        />

                                                        <label htmlFor="email">
                                                            {t('contactEmailLabel')}
                                                        </label>
                                                    </div>


                                                    {/* Query / Message */}
                                                    <div className="form-floating mb-3">
                                                        <textarea
                                                            id="message"
                                                            name="query"
                                                            className="form-control"
                                                            placeholder={t('contactMessage')}
                                                            style={{ height: "130px" }}
                                                            value={contactForm?.msg || ""}
                                                            maxLength={2000}
                                                            required
                                                            onChange={(e) =>
                                                                setContactForm((pv) => ({
                                                                    ...pv,
                                                                    msg: e.target.value
                                                                }))
                                                            }
                                                        ></textarea>

                                                        <label htmlFor="message">
                                                            {t('contactMessage')}
                                                        </label>
                                                    </div>


                                                    {/* Submit Button */}
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="submit"
                                                            className="btn contact-btn"
                                                            style={{
                                                                backgroundColor: "rgba(9, 26, 58, 1)",
                                                                color: "white"
                                                            }}
                                                            data-aos="zoom-in"
                                                            data-aos-delay="200"
                                                        >
                                                            {t('sendMessage')}
                                                        </button>
                                                    </div>

                                                </form>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </section >
                }

                {location.pathname !== "/" && (
                    <>
                        {location.pathname === "/contact-us" &&
                            <div className="contact-page-content container py-5">
                                <div className="row align-items-center">
                                    {/* Left Column: Map */}
                                    <div className="col-lg-6 mb-4 mb-lg-0">
                                        <iframe
                                            title="Office Map"
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.3743570922056!2d80.21625237409668!3d13.011816187307225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52676a7d015597%3A0x2afe4f6a01c8bbc6!2sTamilnadu%20Warehousing%20Corporation%20HO!5e0!3m2!1sen!2sin!4v1771387578731!5m2!1sen!2sin"
                                            width="100%"
                                            height="400"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                        ></iframe>
                                    </div>

                                    {/* Right Column: Images */}
                                    <div className="col-lg-6 d-flex flex-column gap-3">
                                        <img
                                            src={web2}
                                            alt="Office 2"
                                            className="img-fluid rounded shadow"
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        <h3 className="text-center my-4"
                            data-aos="fade-up">{t('warehouseAddress')}</h3>

                        <div className="container py-4">

                            <div className="accordion" id="branchAccordion">

                                {Object.keys(data).map((region, index) => (
                                    <div
                                        className="accordion-item modern-accordion-item"
                                        key={region}
                                    >

                                        <h2 className="accordion-header" id={`heading${index}`}>
                                            <button
                                                className={`accordion-button modern-accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}`}
                                                aria-expanded={index === 0 ? "true" : "false"}
                                                aria-controls={`collapse${index}`}
                                            >
                                                <span className="region-title">{region} Region</span>

                                            </button>
                                        </h2>

                                        <div
                                            id={`collapse${index}`}
                                            className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                            data-bs-parent="#branchAccordion"
                                            aria-labelledby={`heading${index}`}
                                        >
                                            <div className="accordion-body">

                                                <div className="row g-4">
                                                    {data[region].map((branch, i) => (
                                                        <div key={i} className="col-12 col-md-4">
                                                            <div className="card modern-card h-100 shadow-sm">
                                                                {branch?.wh_img ? (
                                                                    <img
                                                                        src={branch.wh_img}
                                                                        className="card-img-top"
                                                                        alt="Warehouse"
                                                                    />
                                                                ) : (
                                                                    <div className=" mb-4 mb-lg-0">
                                                                        <iframe
                                                                            title="Office Map"
                                                                            src={branch?.map}
                                                                            width="100%"
                                                                            height="200"
                                                                            style={{ border: 0 }}
                                                                            allowFullScreen=""
                                                                            loading="lazy"
                                                                        ></iframe>
                                                                    </div>
                                                                )}
                                                                <div div className="card-body">
                                                                    <h6><strong style={{ color: "#0A2158" }}>{branch.wh_name}</strong></h6>
                                                                    <small className="" >
                                                                        <strong>
                                                                            {/* Branch Name */}
                                                                            <span className="info-item m-0">
                                                                                <i className="bi bi-person-fill text-primary"></i>
                                                                                <p className="m-0">{branch.name}</p>
                                                                            </span>

                                                                            {/* Phone */}
                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    window.location.href = `tel:${branch.ofc_phn || branch.phone_no}`
                                                                                }
                                                                                className="info-item border-0 bg-transparent p-0"
                                                                                style={{
                                                                                    color: "inherit",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                            >
                                                                                <i className="bi bi-telephone-fill text-info"></i>
                                                                                <p className="m-0">
                                                                                    {maskPhone(branch.ofc_phn || branch.phone_no)}
                                                                                </p>
                                                                            </button>
                                                                        </strong>

                                                                        {/* Email */}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                window.location.href = `mailto:${branch.email}`
                                                                            }
                                                                            className="info-item border-0 bg-transparent p-0"
                                                                            style={{
                                                                                color: "inherit",
                                                                                cursor: "pointer"
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-envelope text-warning"></i>
                                                                            <p className="m-0">
                                                                                {maskEmail(branch.email)}
                                                                            </p>
                                                                        </button>

                                                                        {/* <br /> */}
                                                                        <span className="info-item m-0">
                                                                            <i className="bi bi-geo-alt text-danger"></i>
                                                                            <p className="m-0">{branch.address} - {branch.pincode}</p>
                                                                        </span>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                ))}

                            </div>

                        </div>

                        {/* Custom styles */}
                        <style jsx>{`
        .modern-accordion-item {
          border: none;
          margin-bottom: 1rem;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 8px 24px rgb(149 157 165 / 0.2);
          transition: box-shadow 0.3s ease;
        }

        .modern-accordion-item:last-child {
          margin-bottom: 0;
        }

        .modern-accordion-item:hover {
          box-shadow: 0 12px 48px rgb(149 157 165 / 0.3);
        }

        .modern-accordion-button {
          background: #3781d4;
          color: white;
          font-weight: 600;
          font-size: 1.125rem;
          padding: 1rem 1.5rem;
          border-radius: 0.75rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-shadow: none !important;
          transition: background-color 0.3s ease;
        }

        .modern-accordion-button.collapsed {
          background: #bdc9da;
          color: #000000;
          border-radius: 0.75rem;
        }

        .modern-accordion-button:hover {
          background-color: #1c5ed6;
          color: white;
        }

        .accordion-icon {
          transition: transform 0.3s ease;
          transform-origin: center;
        }

        .modern-accordion-button.collapsed .accordion-icon {
          transform: rotate(0deg);
        }

        .modern-accordion-button:not(.collapsed) .accordion-icon {
          transform: rotate(180deg);
        }

        .modern-card {
          border-radius: 0.75rem;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
        }

        .modern-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 24px rgb(0 0 0 / 0.12);
        }

        .branch-name {
          font-size: 0.95rem;
          font-weight: 500;
          color: #333;
          line-height: 1.4;
        }

        /* Responsive tweak for smaller devices */
        @media (max-width: 576px) {
          .modern-accordion-button {
            font-size: 1rem;
          }
        }
                          `}</style>
                    </>
                )}
            </div>
        </div >
    );
}

export default Contact;